import React, { useEffect } from 'react';
import { CookieCategory, isCookieConsentGiven } from 'src/utils/cookie';

const ADVERTS = {
  advert__modal__1: {
    slot: '/12650263/hucustom1',
    dimensions: [1, 1],
    id: 'gpt-ad-1',
  },
  advert__modal__2: {
    slot: '/12650263/hucustom2',
    dimensions: [1, 1],
    id: 'gpt-ad-2',
  },
};

const AdvertModal = ({ name }) => {
  useEffect(() => {
    if (!isCookieConsentGiven(CookieCategory.Advertising)) return;
    displayAd();
  }, []);

  const displayAd = () => {
    const { slot, dimensions, id } = ADVERTS[name];
    let ad;

    if (slot && dimensions && id) {
      googletag.cmd.push(() => {
        ad = googletag.defineSlot(slot, dimensions, id); // construct ad slot
        if (ad) ad.addService(googletag.pubads());
      });
      // render ad slot
      googletag.cmd.push(() => googletag.display(id));
    }
  };

  return (
    <div className={name} id={ADVERTS[name].id} />
  );
};

export default AdvertModal;
